import React from 'react'
import classNames from 'classnames'

import { T } from 'lib/tolgee'
import './index.scss'

const EmptyStateNoData = ({ image, title, text, className }) => {
  return (
    <div className={classNames('EmptyStateNoData', className)}>
      {image}
      <div>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </div>
  )
}

export default EmptyStateNoData

EmptyStateNoData.defaultProps = {
  title: <T keyName="EmptyStateNoData">No data to show</T>,
}
